module.exports = __webpack_public_path__ + "static/media/heartshape.15efa4e5.jpg";